import { Ng2StateDeclaration } from '@uirouter/angular';
import { Transition } from '@uirouter/core';

import { ProjectRegistrationComponent } from './projectRegistration/project.registration.component';
import { OrgRegistrationComponent } from './projectRegistration/orgRegistration/org.registration.component';
import { ProjectTroveComponent } from './projectTrove/project.trove.component';
import { TopMenuComponent } from '../topmenu/topmenu/topmenu.component';
import { ProjectHeaderComponent } from './projectHeader/project.header.component';
import { ProjectHomeComponent } from './projectHome/project.home.component';
import { EmbeddedChatComponent } from '../../../plugins/chat/embedded/chat.embedded.component';
import { SearchComponent } from '../search/search.component';
import { TrackerAddComponent } from '../../../plugins/tracker/trackerAdmin/trackerAdd/tracker.add.component';
import { NotificationHistoryComponent } from '../../../widgets/gf-notification-history/gf-notification-history.component';
import { ProjectMainViewComponent } from './projectMain/project.main.view.component';

import { ProjectAdminHeaderComponent } from './admin/projectAdminHeader/project.admin.header.component';
import { ProjectAdminOrgsComponent } from './admin/projectAdminOrgs/project.admin.orgs.component';
import { ProjectAdminHomepageComponent } from './admin/projectAdminHomepage/project.admin.homepage.component';
import { ProjectAdminModulesComponent } from './admin/projectAdminModules/project.admin.modules.component';
import { ProjectAdminScmComponent } from './admin/projectAdminScm/project.admin.scm.component';
import { ProjectAdminScmAclComponent } from './admin/projectAdminScm/projectAdminScmAcl/project.admin.scm.acl.component';
import { ProjectAdminTrackerComponent } from './admin/projectAdminTracker/project.admin.tracker.component';
import { ProjectAdminRolesComponent } from './admin/projectAdminRoles/project.admin.roles.component';
import { ProjectAdminGroupsComponent } from './admin/projectAdminGroups/project.admin.groups.component';
import { ProjectAdminEditComponent } from './admin/projectAdminEdit/project.admin.edit.component';
import { ProjectAdminSnapshotsComponent } from './admin/projectAdminSnapshots/project.admin.snapshots.component';
import { ProjectAdminTroveComponent } from './admin/projectAdminTrove/project.admin.trove.component';
import { ProjectAdminNotificationsComponent } from './admin/projectAdminNotifications/project.admin.notifications.component';
import { ProjectAdminAiFlowComponent } from './admin/projectAdminAiFlow/project.admin.ai-flow.component';
import { ProjectAdminKnowledgeIndexComponent } from './admin/projectAdminKnowledgeIndex/project.admin.knowledge-index.component';
import { ProjectAdminWebhooksSubscriptionsComponent } from './admin/projectAdminWebhooks/project.admin.webhooks.subscriptions.component';
import { ProjectAdminWebhooksDeliveriesComponent } from './admin/projectAdminWebhooks/project.admin.webhooks.deliveries.component';
import { ProjectTeamComponent } from './projectTeam/project.team.component';
import { ProjectSprintsComponent } from './projectSprints/project.sprints.component';
import { ProjectSprintDetailComponent } from './projectSprints/projectSprintDetail/project.sprint.detail.component';
import { ProjectStandupComponent } from './projectStandup/project.standup.component';
import { OrgMembersAuditComponent } from '../admin/orgs/orgMembersAudit/org.members-audit.component';
import { ProjectResolvesService } from './project-resolves.service';
import { ProjectAdminResolvesService } from './project-admin-resolves.service';

export const PROJECT_STATES: any[] = [
    // 'abstract' state, if we load this url the 'home' state will be
    // loaded, that is, the splash page.
    {
        name: 'home.project',
        url: 'project', // URL: /project
        abstract: true,
        resolve: [
            {
                token: 'user',
                deps: [ProjectResolvesService],
                resolveFn: async (projectResolvesService) => projectResolvesService.user()
            }
        ]
    },
    {
        name: 'home.project.register',
        url: '/register', // URL: /project/register
        views: {
            'contentarea@home': {
                component: ProjectRegistrationComponent
            }
        }
    },
    {
        name: 'home.project.register.org',
        url: '/org', // URL: /project/register/org
        views: {
            'contentarea@home': {
                component: OrgRegistrationComponent
            }
        }
    },
    {
        name: 'home.project.trove',
        url: '/categories?:selected', // URL: /project/register
        reloadOnSearch: false,
        resolve: [
            {
                token: 'tour',
                deps: [ProjectResolvesService],
                resolveFn: async (projectResolvesService) => projectResolvesService.projectTroveTour()
            }
        ],
        views: {
            'contentarea@home': {
                component: ProjectTroveComponent
            }
        }
    },
    {
        name: 'home.project.summary',
        url: '/:unixName', // URL: /project/PROJECT_UNIXNAME
        data: {
            searchContext: ['trackeritem', 'scm', 'wiki', 'docman'],
            showProjectHeader: true
        },
        resolve: [
            {
                token: 'project',
                deps: [ProjectResolvesService, '$transition$'],
                resolveFn: async (projectResolvesService, $transition$) => projectResolvesService.project($transition$, $transition$.params().unixName)
            },
            {
                token: 'projectMenu',
                deps: [ProjectResolvesService, '$transition$'],
                resolveFn: async (projectResolvesService, $transition$) => projectResolvesService.projectMenu($transition$.params().unixName)
            },
            {
                token: 'isProjectAdmin',
                deps: [ProjectResolvesService, 'project'],
                resolveFn: (projectResolvesService, project) => projectResolvesService.isProjectAdmin(project)
            },
            {
                token: 'tour',
                deps: [ProjectResolvesService, '$transition$'],
                resolveFn: async (projectResolvesService, $transition$) => projectResolvesService.projectSummaryTour($transition$)
            }
        ],
        views: {
            'topMenu@home': {
                component: TopMenuComponent,
                bindings: {
                    project: 'project',
                    projectMenu: 'projectMenu'
                }
            },
            'contentarea@home': {
                component: ProjectMainViewComponent
            },
            'projectheader@home.project.summary': {
                component: ProjectHeaderComponent
            },
            'contentarea@home.project.summary': {
                component: ProjectHomeComponent
            },
            'sidebar@home.project.summary': {
                component: EmbeddedChatComponent
            }
        }
    },
    {
        name: 'home.project.summary.members',
        url: '/members?search&role&project&membership_type&activity&tab&page_num&page_size&sort_field&sort_dir',
        data: {
            showProjectHeader: true
        },
        params: {
            search: { value: '', squash: true },
            role: { value: '', squash: true },
            project: { value: '', squash: true },
            membership_type: { value: '', squash: true },
            activity: { value: '', squash: true },
            tab: { value: 'members', squash: true },
            page_num: { type: 'int', value: 0, squash: true },
            page_size: { type: 'int', value: 20, squash: true },
            sort_field: { value: '', squash: true },
            sort_dir: { value: '', squash: true }
        },
        resolve: [
            {
                token: 'security',
                deps: [ProjectResolvesService, 'isProjectAdmin', '$transition$'],
                resolveFn: async (projectResolvesService, isProjectAdmin, $transition$) => {
                    if (!isProjectAdmin) {
                        return $transition$.router.stateService.target('home.project.summary', $transition$.params());
                    }
                }
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: OrgMembersAuditComponent
            }
        }
    },
    { // Register a child project
        name: 'home.project.summary.register',
        url: '/register', // URL: /project/:unixName/register
        views: {
            'contentarea@home': {
                component: ProjectRegistrationComponent
            }
        }
    },
    {
        name: 'home.project.summary.search',
        url: '/search?page_num&page_size&q&s&p&c',
        params: {
            page_num: {
                value: "1",
                squash: true,
                dynamic: true
            },
            page_size: {
                value: "20",
                squash: true,
                dynamic: true
            },
            // q: Query - The search keywords/text
            q: {
                value: '',
                squash: true,
                raw: true,
                dynamic: true
            },
            // s: Sections - Comma-separated list of sections to search on
            // e.g., 'trackeritem,scmcommit,wiki,project,user,scm,docman,forum'
            s: {
                value: 'trackeritem,scmcommit,wiki',
                squash: true,
                raw: true,
                dynamic: true
            },
            // p: Project - The project unix name to scope the search to (null for site-wide)
            p: {
                value: null,
                squash: true,
                raw: true,
                dynamic: true
            },
            // c: Categories - Comma-separated list of Trove category IDs to filter results
            c: {
                value: null,
                squash: true,
                raw: true,
                dynamic: true
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: SearchComponent
            }
        }
    },
    // Abstract parent for admin tabs
    // Default child is 'home.project.summary.admin.modules', below
    {
        name: 'home.project.summary.admin',
        abstract: true,
        url: '/admin', // URL: /project/PROJECT_UNIXNAME/admin
        data: {
            searchContext: ['user', 'project']
        },
        resolve: [
            {
                token: 'security',
                deps: [ProjectAdminResolvesService, '$transition$', 'isProjectAdmin'],
                resolveFn: async (projectAdminResolvesService, $transition$, isProjectAdmin) => projectAdminResolvesService.adminSecurity($transition$, isProjectAdmin)
            },
            {
                token: 'roles',
                deps: [ProjectAdminResolvesService, '$transition$'],
                resolveFn: async (projectAdminResolvesService, $transition$) => projectAdminResolvesService.adminRoles($transition$.params().unixName)
            },
            {
                token: 'modules',
                deps: [ProjectAdminResolvesService, '$transition$'],
                resolveFn: async (projectAdminResolvesService, $transition$) => projectAdminResolvesService.adminModules($transition$.params().unixName)
            }
        ],
        views: {
            'projectheader@home.project.summary': {
                component: ProjectAdminHeaderComponent,
                bindings: {
                    project: 'project',
                    modules: 'modules',
                    isProjectAdmin: 'isProjectAdmin',
                    projectMenu: 'projectMenu'
                }
            }
        }
    },
    {
        name: 'home.project.summary.admin.orgs',
        url: '/orgs',
        resolve: [
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminOrgsTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminOrgsComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.homepage',
        url: '/homepage',
        params: {
            pageName: {
                value: 'ProjectHome',
                squash: true
            }
        },
        resolve: [
            {
                token: 'useCustomSplash',
                deps: [ProjectAdminResolvesService, 'project'],
                resolveFn: async (projectAdminResolvesService, project) => projectAdminResolvesService.adminUseCustomSplash(project)
            },
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService, '$transition$'],
                resolveFn: async (projectAdminResolvesService, $transition$) => projectAdminResolvesService.adminHomepageTour($transition$)
            }
        ],
        redirectTo: (transition: Transition) => ({
            state: 'home.project.summary.admin.homepage.view',
            params: transition.params()
        }),
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminHomepageComponent
            }
        }
    },
    // Tab substates — empty URL markers; <wiki-container> swaps content by reading the active state.
    { name: 'home.project.summary.admin.homepage.view', url: '/view' },
    { name: 'home.project.summary.admin.homepage.edit', url: '/edit' },
    { name: 'home.project.summary.admin.homepage.versions', url: '/versions' },
    {
        name: 'home.project.summary.admin.modules',
        url: '', // This makes it the default tab for admin route
        resolve: [],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminModulesComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.scm',
        url: '/scm',
        resolve: [
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminScmTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminScmComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.scm.acl',
        url: '/acl',
        resolve: [
            {
                token: 'acl',
                deps: [ProjectAdminResolvesService, '$transition$'],
                resolveFn: async (projectAdminResolvesService, $transition$) => projectAdminResolvesService.adminScmAcl($transition$.params().unixName)
            },
            {
                token: 'roles',
                deps: [ProjectAdminResolvesService, '$transition$'],
                resolveFn: async (projectAdminResolvesService, $transition$) => projectAdminResolvesService.adminScmRoles($transition$.params().unixName)
            },
            {
                token: 'scm',
                deps: [ProjectAdminResolvesService, '$transition$'],
                resolveFn: async (projectAdminResolvesService, $transition$) => projectAdminResolvesService.adminScm($transition$.params().unixName)
            },
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminScmAclTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminScmAclComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.tracker',
        url: '/tracker',
        resolve: [
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminTrackerTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminTrackerComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.tracker.add',
        url: '/add',
        views: {
            'contentarea@home.project.summary': {
                component: TrackerAddComponent,
                bindings: {
                    project: 'project',
                    siteConfig: 'siteConfig'
                }
            }
        }
    },
    {
        name: 'home.project.summary.admin.roles',
        url: '/roles?:roleId',
        resolve: [
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminRolesTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminRolesComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.groups',
        url: '/groups?page_num&page_size&sort_field&sort_dir&name&groupUnixName',
        params: {
            page_num: { type: 'int', value: 1, squash: true },
            page_size: { type: 'int', value: 20, squash: true },
            sort_field: { value: 'id', squash: true },
            sort_dir: { value: 'asc', squash: true },
            name: { value: null, squash: true },
            groupUnixName: { value: null, squash: true }
        },
        resolve: [
            {
                token: 'groups',
                deps: [ProjectAdminResolvesService, '$transition$'],
                resolveFn: async (projectAdminResolvesService, $transition$) => projectAdminResolvesService.adminGroups($transition$.params().unixName, $transition$.params())
            },
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminGroupsTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminGroupsComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.edit',
        url: '/edit',
        resolve: [
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminEditTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminEditComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.snapshots',
        url: '/snapshots',
        resolve: [
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminSnapshotsTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminSnapshotsComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.trove',
        url: '/categories',
        resolve: [
            {
                token: 'tour',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.adminTroveTour()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminTroveComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.notification',
        url: '/notification',
        redirectTo: 'home.project.summary.admin.notification.history'
    },
    {
        name: 'home.project.summary.admin.notification.send',
        url: '/send',
        reloadOnSearch: false,
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminNotificationsComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.notification.history',
        url: '/history?page_size&page_num&sort_field&sort_dir&section&user&subject&dateRange&dateStart&dateEnd',
        params: {
            page_num: {
                value: 1,
                type: 'int',
                squash: true
            },
            page_size: {
                value: 20,
                type: 'int',
                squash: true
            },
            sort_field: {
                value: 'id',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            section: {
                value: '',
                squash: true
            },
            user: {
                value: '',
                squash: true
            },
            subject: {
                value: '',
                squash: true
            },
            dateRange: {
                value: '',
                squash: true
            },
            dateStart: {
                value: '',
                squash: true
            },
            dateEnd: {
                value: '',
                squash: true
            }
        },
        views: {
            'contentarea@home.project.summary': {
                component: NotificationHistoryComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.aiflow',
        url: '/aiflow',
        resolve: [],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminAiFlowComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.knowledgeindex',
        url: '/knowledgeindex',
        resolve: [],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminKnowledgeIndexComponent
            }
        }
    },
    {
        name: 'home.project.summary.admin.webhooks',
        url: '/webhooks',
        redirectTo: 'home.project.summary.admin.webhooks.subscriptions',
        resolve: [
            {
                token: 'flagGuard',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.requireFlowFeature()
            }
        ],
    },
    {
        name: 'home.project.summary.admin.webhooks.subscriptions',
        url: '/subscriptions',
        resolve: [
            {
                token: 'flagGuard',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.requireFlowFeature()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminWebhooksSubscriptionsComponent,
                bindings: { project: 'project' }
            }
        }
    },
    {
        name: 'home.project.summary.admin.webhooks.deliveries',
        url: '/deliveries?page_num&page_size&sort_field&sort_dir&subscription_id&event_type&status&date_start&date_end',
        reloadOnSearch: false,
        params: {
            page_num: {
                value: '1',
                squash: true
            },
            page_size: {
                value: '20',
                squash: true
            },
            sort_field: {
                value: 'date',
                squash: true
            },
            sort_dir: {
                value: 'desc',
                squash: true
            },
            subscription_id: {
                value: '',
                squash: true
            },
            event_type: {
                value: '',
                squash: true
            },
            status: {
                value: '',
                squash: true
            },
            date_start: {
                value: '',
                squash: true
            },
            date_end: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'flagGuard',
                deps: [ProjectAdminResolvesService],
                resolveFn: async (projectAdminResolvesService) => projectAdminResolvesService.requireFlowFeature()
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectAdminWebhooksDeliveriesComponent,
                bindings: { project: 'project' }
            }
        }
    },
    {
        name: 'home.project.summary.team',
        url: '/team?view&role&search&groups&page_num&page_size', // URL: /project/PROJECT_UNIXNAME/team,
        data: {
            showProjectHeader: true
        },
        params: {
            page_num: { type: 'int', value: 1, squash: true },
            page_size: { type: 'int', value: 20, squash: true },
            role: { type: 'string', value: '', squash: true },
            search: { type: 'string', value: '', squash: true },
            groups: { type: 'string', value: 'true', squash: true },
            view: { type: 'string', value: 'members', squash: true }
        },
        reloadOnSearch: true,
        resolve: [
            {
                token: 'security',
                deps: [ProjectResolvesService, 'isProjectAdmin', '$transition$'],
                resolveFn: async (projectResolvesService, isProjectAdmin, $transition$) => projectResolvesService.projectTeamSecurity(isProjectAdmin, $transition$)
            }
        ],
        views: {
            'projectheader@home.project.summary': {
                component: ProjectHeaderComponent
            },
            'contentarea@home.project.summary': {
                component: ProjectTeamComponent
            }
        }
    },
    {
        name: 'home.project.summary.sprints',
        url: '/sprints?page_num&page_size&sort_field&sort_dir&sprint_id&text&sprint_status&sprint_progression&sprint_start&sprint_end', // URL: /project/PROJECT_UNIXNAME/sprints,
        resolve: [
            {
                token: 'tour',
                deps: [ProjectResolvesService],
                resolveFn: async (projectResolvesService) => projectResolvesService.sprintsTour()
            }
        ],
        params: {
            sprint_id: { value: '', squash: true },
            text: { value: '', squash: true },
            sprint_status: { value: '', squash: true },
            sprint_progression: { value: '', squash: true },
            sprint_start: { value: '', squash: true },
            sprint_end: { value: '', squash: true },
            page_num: { type: 'int', value: 1, squash: true },
            page_size: { type: 'int', value: 10, squash: true },
            sort_field: { value: 'sprint_id', squash: true },
            sort_dir: { value: 'desc', squash: true }
        },
        data: {
            searchContext: ['trackeritem']
        },
        views: {
            'contentarea@home.project.summary': {
                component: ProjectSprintsComponent
            }
        }
    },
    {
        name: 'home.project.summary.sprint',
        // URL: /project/PROJECT_UNIXNAME/sprints/ID,
        url: '/sprint/:id?page_num&page_size&sort_field&sort_dir&status',
        data: {
            searchContext: ['trackeritem']
        },
        params: {
            page_num: { type: 'int', value: 1, squash: true },
            page_size: { type: 'int', value: 10, squash: true }
        },
        reloadOnSearch: false,
        resolve: [
            {
                token: 'sprint',
                deps: [ProjectResolvesService, '$transition$'],
                resolveFn: async (projectResolvesService, $transition$) => projectResolvesService.sprintDetail($transition$.params().id)
            },
            {
                token: 'tour',
                deps: [ProjectResolvesService, 'sprint'],
                resolveFn: async (projectResolvesService, sprint) => projectResolvesService.sprintTour(sprint)
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectSprintDetailComponent
            }
        }
    },
    // Tab substates for the completed-sprint retrospective
    { name: 'home.project.summary.sprint.view', url: '/view' },
    { name: 'home.project.summary.sprint.edit', url: '/edit' },
    { name: 'home.project.summary.sprint.versions', url: '/versions' },
    {
        name: 'home.project.summary.standup',
        url: '/standup?view&user', // URL: /project/PROJECT_UNIXNAME/standup/USER_UNIXNAME,
        reloadOnSearch: false,
        params: {
            view: {
                value: 'project',
                squash: true
            },
            user: {
                value: '',
                squash: true
            }
        },
        resolve: [
            {
                token: 'security',
                deps: [ProjectResolvesService, 'isProjectAdmin', '$transition$'],
                resolveFn: async (projectResolvesService, isProjectAdmin, $transition$) => projectResolvesService.standupSecurity(isProjectAdmin, $transition$)
            }
        ],
        views: {
            'contentarea@home.project.summary': {
                component: ProjectStandupComponent
            }
        }
    }
];
